// Needed because we want to format independently of the locale
/* eslint eag/no-external-date-time-format-functions: 0 */
import {format} from 'date-fns';

import {parseDate} from 'shared/web';

export const formatDataGridExportDate = (date: Date): string =>
  format(parseDate(date), 'yyyy-MM-dd_HH-mm-ss');
